import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_PARTNER_PROMO_CODES = createRequestTypes('ENTITIES_PARTNER_PROMO_CODES')
export const ENTITIES_CREATE_PROMO_CODE = createRequestTypes('ENTITIES_CREATE_PROMO_CODE')
export const ENTITIES_UPDATE_PROMO_CODE = createRequestTypes('ENTITIES_UPDATE_PROMO_CODE')

export const partnerPromoCodes = {
  request: partnerId => action(ENTITIES_PARTNER_PROMO_CODES.REQUEST, { partnerId }),
  success: (partnerId, response) => action(ENTITIES_PARTNER_PROMO_CODES.SUCCESS, { partnerId, response }),
  failure: (partnerId, error) => action(ENTITIES_PARTNER_PROMO_CODES.FAILURE, { partnerId, error }),
}

export const createPromoCode = {
  request: () => action(ENTITIES_CREATE_PROMO_CODE.REQUEST),
  success: (promoCodeId, response) => action(ENTITIES_CREATE_PROMO_CODE.SUCCESS, { promoCodeId, response }),
  failure: (promoCodeId, error) => action(ENTITIES_CREATE_PROMO_CODE.FAILURE, { promoCodeId, error }),
}

export const updatePromoCode = {
  request: () => action(ENTITIES_UPDATE_PROMO_CODE.REQUEST),
  success: (promoCodeId, response) => action(ENTITIES_UPDATE_PROMO_CODE.SUCCESS, { promoCodeId, response }),
  failure: (promoCodeId, error) => action(ENTITIES_UPDATE_PROMO_CODE.FAILURE, { promoCodeId, error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/promo-code/promo-code-actions.js
 **/